'use client'
import { Faqs } from 'pageSections/Faqs'
import Section from 'components/Section'
import { Grid } from '@achieve/ascend'
import { useMemo } from 'react'
import { _get } from 'utils/shared'
import { ArticleListCarousel } from 'components/ArticleListCarousel'

export function ArticleClientFooter({ content, isNotSimpleContentType }) {
  const relatedArticles = _get(content, 'relatedArticles.items')
  const faq = _get(content.articleData, 'items[0].fields.faq')
  const ArticleCarousel = useMemo(
    () => <ArticleListCarousel relatedArticles={relatedArticles} unifiedArticleLink />,
    [relatedArticles]
  )

  return (
    <>
      {faq && (
        <Faqs
          content={{
            faqs: { faqSetsCollection: { items: faq?.fields.faqSets } },
            config: { jsonContent: { color: 'highlight-blue' } },
            show: 3,
            title: {
              fieldName: 'title',
              textContent: faq?.fields?.name || 'Frequently Asked Questions',
            },
          }}
          answerTextVariant="bodyMd"
          questionTextVariant="headingMd"
          titleProps={{
            classNameTitleText: 'lg:text-left',
            variants: {
              title: 'headingLg',
              titleFontWeight: 'medium',
            },
          }}
          fullWidth={true}
        />
      )}
      {isNotSimpleContentType && (
        <Section data-testid="article-footer-section">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            {ArticleCarousel}
          </Grid>
        </Section>
      )}
    </>
  )
}
